<template>
  <MainLayout section="overview">
    <b-container fluid id="overview-container" v-bind:class="$mq">
      <b-row>
        <b-col id="deprecated">
          <p>The xrpintel reporting API has been deprecated due to lack of resources to maintain.</p>

          <p>We'd like to thank everyone that used and supported the service up to this point.</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="mt-3 overview_card" v-bind:class="$mq">
          <div class="card_icon pb-3">
            <div id="txs_header" v-bind:class="$mq">
              <span>
                <b>Live Transactions</b>
                <TxsControl />
              </span>

              <span>
                <TxsFilter />
              </span>
            </div>

            <LiveTxs />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </MainLayout>
</template>

<script>
import MainLayout    from './components/MainLayout.vue'
import LiveTxs       from './components/LiveTxs.vue'
import TxsFilter     from './components/TxsFilter.vue'
import TxsControl    from './components/TxsControl.vue'

export default {
  name: 'Overview',

  components: {
    MainLayout,
    LiveTxs,
    TxsFilter,
    TxsControl
  }
}
</script>

<style scoped>
#overview-container{
  flex-grow: 1;
  padding: 25px;
  margin: 0;
  background-image: linear-gradient(transparent 75px, #eef1f6 10px);
  align-items: stretch;
}

#overview-container.sm {
  font-size: 0.8rem;
}

#deprecated{
  background: rgba(255,243,205,.85);
  padding: 15px;
  font-weight: bold;
}

#txs_header {
  overflow: auto;
  background-color: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-right: 1px; 
}

#txs_header.sm{
  font-size: 1.2em;
}
</style>
